module.exports = __webpack_public_path__ + "static/media/img148.b4a771f0.jpg";